
<template>
    <Section>
        <header class="result--actions" v-if="totalResults > 0 && !searchError">
            <span>Display results by:</span>
            <div class="btn__group btn__group--toggle">
                <Button
                    @click="organiseDisplay = true"
                    :aria-selected="organiseDisplay"
                    :class="{ 'btn--active' : organiseDisplay }"
                >Group</Button>

                <Button
                    @click="organiseDisplay = false"
                    :aria-selected="!organiseDisplay"
                    :class="{ 'btn--active' : !organiseDisplay }"
                >Relevance</Button>
            </div>
        </header>

        <template v-if="organiseDisplay && totalResults > 0 && !searchError">
            <ContainerResultsMostRelevant :mostRelevantResults="mostRelevantResults" />

            <Content>
                <h2>All Results - {{ totalFilteredResults }} results found</h2>

                <Section class="section--area-content section--area-search">
                            <Button @click="toggleFilters" class="filters__toggle" display="secondary" style="width: 100%; justify-content: center;">
                                {{ filtersVisible ? 'Hide' : 'Show' }} Filters
                            </Button>
                            <Filters ref="filter1" class="grid--side" />
                            <ContainerAreaResources
                                v-if="totalFilteredResults > 0"
                                :resources="filteredResources"
                                :isSearch="true"
                                :showArea="true"
                            />
                            <Alert title="Sorry!" type="warning" v-else>
                                <p>There are no resources matching your filters.</p>
                            </Alert>
                </Section>
            </Content>
        </template>

        <template v-if="!organiseDisplay && totalResults > 0 && !searchError">
            <h2>All Results - {{ totalFilteredResults }} results found</h2>

            <Section class="section--area-content section--area-search">
                    <Button @click="toggleFilters" class="filters__toggle" display="secondary" style="width: 100%; justify-content: center;">
                        {{ filtersVisible ? 'Hide' : 'Show' }} Filters
                    </Button>
                    <Filters ref="filter2" class="grid--side" :hideCategories="false" />

                    <Section class="resources grid--resources">
                        <CardResource class="grid--resources"
                            v-for="result in filteredResources"
                            :key="`allResults-${result.name}-${result.id}`"
                            v-bind="result"
                            :showArea="true"
                            :showAllMeta="true"
                        />
                    </Section>
            </Section>
        </template>

        <Content v-if="totalResults === 0 && !searchError">
            Sorry, we couldn't find any resources that matched your query.
        </Content>

        <Content v-if="searchError">
            {{ searchError }}
        </Content>
    </Section>
</template>

<script>
import { mapState } from 'vuex'
import { chunkArray } from '@/helpers'
import gsap from 'gsap'

export default {
    data() {
        return {
            organiseDisplay: true,
            filtersVisible: false
        }
    },

    watch: {
        organiseDisplay () {
            this.hideFilters()
        }
    },

    computed: {
        ...mapState('Resources', ['searchResults', 'searchFilters', 'searchError']),
        mostRelevantResults() {
            return chunkArray(this.searchResults, 3)[0] },

        hasFilters () {
            return Object.values(this.searchFilters).filter(filter => filter.length > 0).length > 0
        },

        filteredResources () {
            const filtered = this.searchResults.filter(res => {
                let matchesFilters = true

                for (let facet in this.searchFilters) {
                    const filters = this.searchFilters[facet]
                    const filteredFacets = filters.length > 0

                    // If filters are selected, and the resource 'res[facet]' does not include the filter,
                    // set the value to false
                    if (filteredFacets && !filters.includes(res[facet])) matchesFilters = false
                }

                return matchesFilters
            })

            return this.hasFilters ? filtered : this.searchResults
        },

        totalResults () { return this.searchResults.length },
        totalFilteredResults () { return this.filteredResources.length },
    },

    methods: {
        toggleFilters () {
            const { filter1, filter2 } = this.$refs
            const el = filter1 ? filter1.$el : filter2.$el
            const top = el.offsetTop

            gsap.to(window, {
                scrollTo: top - 100,
                duration: .4,
                ease: 'power4.ease-out'
            })

            return this.filtersVisible ? this.hideFilters() : this.showFilters()
        },

        showFilters () {
            const { filter1, filter2 } = this.$refs
            this.filtersVisible = true

            const el = filter1 ? filter1.$el : filter2.$el

            gsap.to(el, {
                height: 'auto',
                duration: .4,
                ease: 'power4.ease-out'
            })
        },

        hideFilters () {
            const { filter1, filter2 } = this.$refs
            this.filtersVisible = false

            const el = filter1 ? filter1.$el : filter2.$el

            gsap.to(el, {
                height: 0,
                duration: .4,
                ease: 'power4.ease-out'
            })
        }
    }
}
</script>
